export const environment = {
  production: true,
  development: false,
  test: false,
  brand: 'VYV',
  apiConfig: {
    scopes: ['api://boiard-tst-back-office/Read.All', 'api://boiard-tst-back-office/Write.All'],
    uri: 'https://tst.assurance.vyv-conseil.fr/api/',
  },
  keycloak: {
    url: 'https://rec.authentification.harmonie-mutuelle.fr/auth',
    realm: 'adherents_rec3',
    clientId: 'vyvconseil_rec3',
    tokenEndpoint: 'authentication/token/hm',
  },
  passConnect: {
    url: 'https://passconnect-preprod.groupe-vyv.fr/auth',
    realm: 'passconnect',
    clientId: 'sequoia-adherent-test',
    tokenEndpoint: 'authentication/token/passconnect',
  },
  appInsightsConfig: {
    connectionString: 'InstrumentationKey=e9c64840-c6be-4cce-b997-91dd6be90ca1;IngestionEndpoint=https://francecentral-1.in.applicationinsights.azure.com/;LiveEndpoint=https://francecentral.livediagnostics.monitor.azure.com/;ApplicationId=0e4916ec-1aeb-4f95-9de2-b775d087beb6',
    maxBatchIntervalMs: '15000',
  },
  ParcoursDeSouscription: {
    AHC: 'https://tst.assurance-habitation.vyv-conseil.fr/product/HC',
    AHP: 'https://tst.assurance-habitation.vyv-conseil.fr/product/HP',
    AHS: 'https://tst.assurance-habitation.vyv-conseil.fr/product/HS',
    AHT: 'https://tst.assurance-habitation.vyv-conseil.fr/product/HT',
  },
  EspaceAdherentUrl: {
    MGEN: "https://www.mgen.fr/login-adherent/",
    HM: "https://harmonie-et-moi.fr/",
    MNT: "https://adherents.mnt.fr/"
  },
  Systempay: {
    endpoint: 'https://api.systempay.fr',
    publicKey: '73852400:testpublickey_HbYVxnyDUy7eCiCL0OK9l8b8PJRG6suXyVpxzdsM1v6cv',
  },
   msalConfig: {
    auth: {
      clientId: 'da23b809-cdb7-4eb1-8e1c-1b1cf64923b3',
      authority: 'https://login.microsoftonline.com/6f12f368-4cb1-4b07-9574-dd2cdf95d9c1',
    },
    enabled: 'true',
  },
};
